import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

const NETWORK_ERROR = 'Network Error'

export default {
    init,
    log,
}

function isSentryEnabled() {
    return process.env.REACT_APP_SENTRY_CLIENT_DNS
}

function init() {
    if (isSentryEnabled()) {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_CLIENT_DNS,
            environment: process.env.REACT_APP_ENVIRONMENT,
            integrations: [new Integrations.BrowserTracing()],
            tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
        })
    }
}

function log(error, info = { fromErrorBoundary: false }) {
    const isNetworkError = error.message && error.message === NETWORK_ERROR
    if (isSentryEnabled()) {
        Sentry.withScope(scope => {
            scope.setExtras(info)
            scope.setTag('online', String(navigator && navigator.onLine))
            if (isNetworkError) {
                Sentry.captureMessage(error.message, Sentry.Severity.Log)
            } else {
                scope.setLevel(info.fromErrorBoundary ? Sentry.Severity.Fatal : Sentry.Severity.Error)
                Sentry.captureException(error)
            }
        })
    } else {
        console.error(error, info)
    }
}
